function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#746b7a;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Remove Connection");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4.75,5.7a.9.9,0,1,0,0,1.8h9.4a.9.9,0,1,0,0-1.8Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.85,9.6H5.25a3,3,0,0,1,0-6h1.6a.9.9,0,0,0,0-1.8H5.25a4.8,4.8,0,0,0,0,9.6h1.6a.9.9,0,1,0,0-1.8Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.25,3.5h1.6a3.00853,3.00853,0,0,1,3,3,3.70733,3.70733,0,0,1-.4,1.5,5.3,5.3,0,0,1,1.5.8,4.64529,4.64529,0,0,0,.6-2.3,4.80106,4.80106,0,0,0-4.8-4.8h-1.6a.89626.89626,0,0,0-.9.9A.98655.98655,0,0,0,12.25,3.5Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.35589,10.10589a4.73859,4.73859,0,0,0,0,6.78822,4.80105,4.80105,0,0,0,6.78822,0,4.73859,4.73859,0,0,0,0-6.78822A4.86606,4.86606,0,0,0,11.35589,10.10589Zm5.79827,1.55563L15.31568,13.5l1.83848,1.83848a.4.4,0,1,1-.56568.56568L14.75,14.06569l-1.83848,1.83847a.4.4,0,1,1-.56568-.56568L14.18431,13.5l-1.90918-1.90919a.4.4,0,0,1,.56568-.56568l1.83848,1.83847,1.83848-1.83847a.43014.43014,0,0,1,.56568,0A.4575.4575,0,0,1,17.15416,11.66152Z"
});

var SvgRemoveConnection = function SvgRemoveConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-connection.8649cdf2.svg";
export { ForwardRef as ReactComponent };